export default "__VITE_ASSET__JMsUTqfl__"